import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Body from 'syf-component-library/ui/typography/Body';
import { formatCurrency } from 'syf-js-utilities/formats';
import { FAR_ANGLE_DOWN, FAR_ANGLE_UP, FAR_CALENDAR_DAY, FAR_EXCLAMATION_CIRCLE } from '../../../../const/iconProps';
import { getEstDateString, isMonthly, isPN4 } from '../../../../helpers';
import useApiMachine from '../../../../hooks/machines/useApiMachine';
import { t } from '../../../../strings/i18n';
import { useField } from '../../../../xform';
import SelectWithFocus from '../../../atoms/SelectWithFocus';
import { PaymentOption, SelectWrapper } from '../subcomponents';
const getHelpTextByProductType = (productType) => {
    if (isPN4(productType)) {
        return 'pn4PayoffHelpText';
    }
    if (isMonthly(productType)) {
        return 'monthlyPayoffHelpText';
    }
    return 'payoffHelpText';
};
const PayoffAmountDateSelect = () => {
    const paymentAmount = useField('paymentAmount');
    const [apiMachine] = useApiMachine();
    const { accountSummaryQueryResult } = apiMachine.context;
    const { data: accountSummary } = accountSummaryQueryResult;
    const paymentHelpText = getHelpTextByProductType(accountSummary.product.type);
    const [year, month, day] = getEstDateString(new Date()).split('-');
    const displayDate = `${month}/${day}/${year}`;
    const displayAmount = formatCurrency(paymentAmount.value);
    const options = [
        {
            element: (_jsx(PaymentOption, Object.assign({ "data-cy": "payment-date-amount-option", vertical: "base" }, { children: _jsxs(Body, Object.assign({ isInline: true, weight: "semiBold" }, { children: [displayDate, " (", displayAmount, ")"] })) }))),
            value: paymentAmount.value,
            label: t('makePayment.payoffAmountDateOption', {
                amount: displayAmount,
                date: displayDate
            })
        }
    ];
    return (_jsx(SelectWrapper, Object.assign({ bottom: "xlarge", top: "medium" }, { children: _jsx(SelectWithFocus, { autoAdjust: true, dataCy: "payment-amount-date", defaultOption: !paymentAmount.isDisabled && options[0], error: paymentAmount.error, errorIcon: _jsx(FontAwesomeIcon, { icon: FAR_EXCLAMATION_CIRCLE, size: "1x" }), helpText: t(`makePayment.${paymentHelpText}`), id: "payoffAmountDate", isDisabled: true, leftIcon: _jsx(FontAwesomeIcon, { icon: FAR_CALENDAR_DAY }), name: "payoffAmountDate", options: options, placeholder: t('makePayment.payoffAmountDateLabel'), required: true, rightIconClosed: _jsx(FontAwesomeIcon, { icon: FAR_ANGLE_DOWN, size: "lg" }), rightIconOpen: _jsx(FontAwesomeIcon, { icon: FAR_ANGLE_UP, size: "lg" }), tabIndex: -1, onChange: ({ value }) => paymentAmount.setValue(value) }) })));
};
export default PayoffAmountDateSelect;
